import { SimpleChartData } from '@/features/360-analysis/charts/SimpleChartEngine/types';

export interface IChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: string;
  chart_data?: SimpleChartData[];
}

export enum ChatStatus {
  IDLE = 'idle',
  SENDING = 'sending',
  STREAMING = 'streaming',
}

